

































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import Cookies from 'js-cookie';
@Component
export default class UnLock extends AbpBase {
    name: string = 'Unlock';
    avatorLeft: string = '0px';
    inputLeft: string = '400px';
    password: string = '';
    check = null;
    @Prop({ type: Boolean, default: false }) showUnlock: boolean;
    get avatorPath() {
        return localStorage.avatorImgPath;
    }
    async validator() {
        let loginModel = {
            userNameOrEmailAddress: this.$store.state.session.user.userName,
            password: window.btoa(this.password), // 调整为简单的base64加密
            rememberMe: false
        }
        if (sessionStorage.getItem('rememberMe') === '1') {
            loginModel.rememberMe = true;
        }
        let res = await this.$store.dispatch({
            type: 'app/login',
            data: loginModel
        })
        return res;
    }
    handleClickAvator() {
        this.avatorLeft = '-180px';
        this.inputLeft = '0px';
        (this.$refs.inputEle as any).focus();
    }
    async handleUnlock() {
        if (await this.validator()) {
            this.avatorLeft = '0px';
            this.inputLeft = '400px';
            this.password = '';
            // Cookies.set('locking', '0');
            abp.utils.setCookieValue('locking', '0');
            this.$emit('on-unlock');
        } else {
            this.$Message.error('WrongPassword,Wrong password');
        }
    }
    unlockMousedown() {
        (this.$refs.unlockBtn as any).className = 'unlock-btn click-unlock-btn';
    }
    unlockMouseup() {
        (this.$refs.unlockBtn as any).className = 'unlock-btn';
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lockscreen/components/unlock.vue